<template>
  <router-view></router-view>
</template>
<script setup>
import useUserDataStore from "@/store/userDataStore"
import apiUser from "@/api/api/apiUser.js"
import router from "@/router/index.js"
import tools from "@/utils/tools.js"
import message from "@/components/functionCallComponent/message/message.js"
import { isDev, isMobileDevice } from "@/utils/tools.js"
import { getLatestUtmSourceFromCookie } from "@/api/net/config.js"
import globleConfig from "@/config/config.js"

import { useRouter, useRoute } from "vue-router"
import { jwtDecode } from "jwt-decode"
// import { AwsRum } from "aws-rum-web"

const globalProperties = getCurrentInstance()?.appContext.config.globalProperties

const Router = useRouter()
const route = useRoute()

const userDataStore = useUserDataStore()

const updateAuthData = (_data) => {
  userDataStore.upDataAuthData(_data.auth)
  userDataStore.updateLoginStatus(true)
}

const getQueryParameter = (name) => {
  const urlParams = new URLSearchParams(window.location.search)
  return urlParams.get(name)
}

const getAccessToken = (url) => {
  const params = new URLSearchParams(url.split("#")[1])
  return params.get("access_token")
}

const loginByIdToken = async (token) => {
  const decoded = jwtDecode(token)
  const { data, code, msg } = await apiUser.userLogin({
    mode: "apple",
    extra_token: getQueryParameter("code") ?? "",
    token: decoded?.sub ?? "",
    source: getLatestUtmSourceFromCookie() ?? "",
    signup_source: userDataStore.getSignupSource(),
    activity_source: userDataStore.getActivitySource(),
  })
  if (code === 200) {
    console.log("第三方登录成功")
    updateAuthData(data)
    const url = new URL(window.location);
    const params = new URLSearchParams(url.search);
    params.delete('id_token');
    url.search = params.toString();
    window.history.replaceState({}, '', url.toString());
  } else if (code == 6401) {
    message.error({
      maskClosable: true,
      position: "top",
      content: "Deleted accounts cannot be registered within 14 days.",
    })
  } else {
    message.error({
      maskClosable: true,
      position: "top",
      content: msg,
    })
  }
}

const loginByAccessToken = async (accessToken) => {
  const { data, code, msg } = await apiUser.userLogin({
    mode: "discord",
    token: accessToken,
    source: getLatestUtmSourceFromCookie() ?? "",
    signup_source: userDataStore.getSignupSource(),
    activity_source: userDataStore.getActivitySource(),
  })
  if (code === 200) {
    console.log("第三方登录成功")
    window.location.hash = ""
    updateAuthData(data)
  } else if (code == 6401) {
    message.error({
      maskClosable: true,
      position: "top",
      content: "Deleted accounts cannot be registered within 14 days.",
    })
  } else {
    message.error({
      maskClosable: true,
      position: "top",
      content: msg,
    })
  }
}

const threeLoginStateGet = async () => {
  const id_token = getQueryParameter("id_token") ?? ""
  if (id_token) {
    await loginByIdToken(id_token)
    return
  }
  const accessToken = getAccessToken(window.location.href) ?? ""
  if (accessToken) {
    await loginByAccessToken(accessToken)
    return
  }

  userDataStore.init()

}

onMounted(async () => {
  threeLoginStateGet()
})

</script>
<style lang="scss">
.lottie-animation-contaniner {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  .lottie-animation-content {
    height: 80px;
    width: 80px;
  }
}
</style>
